<template>
  <div class="wrapper">
    <parallax class="page-header header-filter"></parallax>
    <div class="">
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto text-center"
            >
              <h2 class="title text-center">Reservation</h2>
              <!-- <md-button
                href="/reserveation"
                class="md-orange md-lg"
                target="_blank"
                ><md-icon>today</md-icon>Reservation Now
              </md-button> -->
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 md-small-xsmall-100 mx-auto">
              <span>{{date}}</span>
            </div>
            <div v-for="(item) in myresult" v-bind:key="item.id" class="md-layout-item md-size-50 md-xsmall-size-100 mx-auto">
            <!-- <div v-for="(item, index) in myresult" v-bind:key="item.id" class="md-layout-item md-size-50 md-xsmall-size-100 mx-auto"> -->
              <img :src="getImgUrl(item.type, 1)" alt="">
              <h3>
                {{item.name}}
              </h3>
              <h5>
              {{item.description}}
              </h5>
              <md-button
                href="javascript:void(0)"
                v-on="selectedRoom(item.id)"
                class="md-orange md-lg"
                target="_blank"
                ><md-icon>today</md-icon>Order
              </md-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    prop: {
      },
    data() {
      return {
        myImg: {
          "img1": [{
              src: require("@/assets/img/NK1.jpg")
            },
            {
              src: require("@/assets/img/NDD1.jpg")
            },
            {
              src: require("@/assets/img/PND2.jpg")
          }],
          "img2": [{
              src: require("@/assets/img/SNK1_1.jpg")
            },
            {
              src: require("@/assets/img/SuiteDoubleFull3_SND2.jpg")
            },
            {
              src: require("@/assets/img/XADABath.jpg")
          }],
          "img3": [{
              src: require("@/assets/img/NK1.jpg")
            },
            {
              src: require("@/assets/img/NDD1.jpg")
            },
            {
              src: require("@/assets/img/PND2.jpg")
          }],
          "img4": [{
              src: require("@/assets/img/SNK1_1.jpg")
            },
            {
              src: require("@/assets/img/SuiteDoubleFull3_SND2.jpg")
            },
            {
              src: require("@/assets/img/XADABath.jpg")
          }],
          "img5": [{
              src: require("@/assets/img/NK1.jpg")
            },
            {
              src: require("@/assets/img/NDD1.jpg")
            },
            {
              src: require("@/assets/img/PND2.jpg")
          }],
          "img6": [{
              src: require("@/assets/img/SNK1_1.jpg")
            },
            {
              src: require("@/assets/img/SuiteDoubleFull3_SND2.jpg")
            },
            {
              src: require("@/assets/img/XADABath.jpg")
          }],
          "img7": [{
              src: require("@/assets/img/NK1.jpg")
            },
            {
              src: require("@/assets/img/NDD1.jpg")
            },
            {
              src: require("@/assets/img/PND2.jpg")
          }],
          "img8": [{
              src: require("@/assets/img/NK1.jpg")
            },
            {
              src: require("@/assets/img/NDD1.jpg")
            },
            {
              src: require("@/assets/img/PND2.jpg")
          }]
        },
        date:'',
        myresult: [],
        selected: {}
      }
    },
    computed: {
      
    },
    methods: {
      // classicModalHide(e) {
      //   this.classicModal[e] = false;
      // }
      getImgUrl: function (e, i) {
        let temp= 'img' + e;
        // if (typeOf(this.myImg) !== 'undefined') ? this.myImg[temp][i] : ''
        // console.log(this.myImg[temp][i])
        return (typeof(this.myImg[temp]) !== 'undefined') ? this.myImg[temp][i].src : ''
      },
      selectedRoom: function (e) {
        console.log(e)
      }
    },
    mounted() {
      // this.$http.get('/api/result').then((response) => {
      //   response = response.body
      //   if (response.errno === 0) {
      //     console.log(response)
      //     this.myresult = response.result
      //   }
      // })
      // const el = Object.assign({}, {
      //   page: 1,
      //   _:1521895305719
      // })
      axios.get('/api/result').then((res) => {
        // console.log(res)
        if(res.status === 200) {
          this.myresult = res.data.result
        } else {
          this.myresult = []
        }
        return this.myresult
      }).catch((error) => {
        console.log(error)
      })
    }
  }
</script>

<style lang="scss" scoped>
  .page-header {
    height: auto;
  }
  .t_main {
    height: 100%;
    position: relative;
  }
</style>